import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import '../css/Popup.css';
import '../css/Login.css';

export default function Popup(props) {
	const { title, msg, close, open, icon, success, hint, tabName } = props;
	return (
		<div> 
			<Dialog open={open}  className="" style={{zIndex:"9999999999"}}>
				<DialogTitle className={'dialogTitle'} sx={{padding:"10px"}}>{icon}</DialogTitle>
				<DialogContent className={'dialogContent'}>
					<h6 className={success ? 'successMessageColor' : 'ErrorMessageColor'}>{title}</h6>
					<p className="ConfirmTitlePara">{msg}</p>
					<div className="appDivider" />
					{hint?(
						<p style={{ fontSize: '16px' }}>
						<b>{hint}</b>
					</p>
				 ):""}
				</DialogContent>
				<DialogActions>
					<div className="buttonDiv">
						<button className="PopupButton" onClick={() => close(tabName)}>
							Ok
						</button>
					</div>
				</DialogActions>
			</Dialog>
		</div>
	);
}
